"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const baseOptions = {
    hour: 'numeric',
    minute: '2-digit',
};
/**
 * Displays a live clock.
 *
 * Please feel free to add additional features - reach out to [#mosaic](slack://channel?team=T02835DET&id=CE299KC1X) for any help or guidance.
 */
const Clock = ({ locales, options }) => {
    const [currentDate, setCurrentDate] = react_1.useState(new Date());
    react_1.useEffect(() => {
        const intervalId = window.setInterval(() => {
            setCurrentDate(new Date());
        }, 1000);
        return () => {
            window.clearInterval(intervalId);
        };
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null, currentDate.toLocaleTimeString(locales, Object.assign(Object.assign({}, baseOptions), options)));
};
exports.default = Clock;
